import { render, staticRenderFns } from "./StudyProgramModule.vue?vue&type=template&id=7b679c34&scoped=true&"
import script from "./StudyProgramModule.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramModule.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramModule.vue?vue&type=style&index=0&id=7b679c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b679c34",
  null
  
)

export default component.exports